import GBMapSearch from "./GBMapSearch";

const MapSearch = () => {
  return (
    <div className="absolute rounded shadow-md m-4 bg-white z-40 top-0 left-0 h-auto w-auto">
      <GBMapSearch />
    </div>
  );
};

export default MapSearch;
